module.exports = __webpack_public_path__ + "f5fe0afa28a2e34df5bbe2247d1879df.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/arrow.png
// module id = ./app/images/arrow.png
// module chunks = 40